import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
    RaisedButton, 
    TableBody, TableRow, TableRowColumn, TableHeader, TableHeaderColumn, Table,
} from 'material-ui';
import PlusIcon from 'material-ui/svg-icons/content/add-circle-outline';
import MinusIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import { connect } from 'react-redux';
import { postRegularForm } from 'helpers/miscellaneous';
import api from 'services';
import './styles.scss';

function Mailers({ userId }) {
    const [mailers, setMailers] = useState([]);

    const handleAddMailer = () => {
        postRegularForm(
            '/api/v1/users/mailGates/fromTemplate/gmail', 
            { userId, isA: true }, 
            '_self',
        );
    };

    const getMailers = () => {
        api.getInternalMailers()
            .then((response) => {
                setMailers(response.data);
            });
    };

    useEffect(() => {
        getMailers();
    }, []);

    /**
     * @param {string} id 
     */
    const removeMailer = (id) => {
        api.removeInternalMailer(id).then(() => getMailers());
    };

    return (
        <div className='container'>
            <div className='table-page'>
                <h2>Mailers</h2>
                <div className='table-header'>
                    <div className='item'>
                        <RaisedButton
                            label='Add Mailer Google'
                            onClick={handleAddMailer} 
                            primary
                        />
                    </div>
                </div>
                <br />
                <Table selectable={false}>
                    <TableHeader 
                        displaySelectAll={false} 
                        adjustForCheckbox={false}
                        className='mailer-table-header'
                    >
                        <TableRow>
                            <TableHeaderColumn>
                                Receiver
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                Enabled
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                Expire time
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                Last update
                            </TableHeaderColumn>
                            <TableHeaderColumn>
                                {null}
                            </TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody 
                        displayRowCheckbox={false}
                        className='mailer-table-body'
                    >
                        {mailers.map(mailer => (
                            <TableRow 
                                key={mailer._id}
                            >
                                <TableRowColumn>
                                    {mailer.receiver.username}
                                </TableRowColumn>
                                <TableRowColumn>

                                    {
                                        mailer.enabled ?
                                            <PlusIcon color='green' />
                                            :
                                            <MinusIcon color='red' />
                                    }
                                </TableRowColumn>
                                <TableRowColumn>
                                    {moment(mailer.auth.expires).format('MMMM Do YYYY, h:mm:ss a')}
                                </TableRowColumn>
                                <TableRowColumn>
                                    {moment(mailer.updatedAt).format('MMMM Do YYYY, h:mm:ss a')}
                                </TableRowColumn>
                                <TableRowColumn>
                                    <RaisedButton
                                        label='Delete'
                                        onClick={() => removeMailer(mailer._id)} 
                                        secondary
                                    />
                                </TableRowColumn>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </div>
        </div>
    );
}

export default connect(
    ({ user }) => ({
        userId: user.user._id,
    }),
    {},
)(Mailers);



// WEBPACK FOOTER //
// ./app/components/Analytics/mailers/Mailers.jsx